module.exports = __webpack_public_path__ + "media/images/flt-logo@2x-f299d49ed510ce57d004ed5de296208c.png";